module.exports = __webpack_public_path__ + "img/saturn.fe28b39.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/saturn.png
// module id = 1297
// module chunks = 1